import { render, staticRenderFns } from "./ModuleShippingSingle.vue?vue&type=template&id=3656157e&scoped=true&"
import script from "./ModuleShippingSingle.vue?vue&type=script&lang=js&"
export * from "./ModuleShippingSingle.vue?vue&type=script&lang=js&"
import style0 from "./ModuleShippingSingle.vue?vue&type=style&index=0&id=3656157e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3656157e",
  null
  
)

export default component.exports